import { ref, watchEffect } from 'vue'
import { defineStore } from 'pinia'
import { useLoadObjectSubTypeSelect } from '@/widgets/ObjectSubTypeSelect/model/api.ts'

export const useObjectSubTypeSelect = defineStore('object_sub_type_select', () => {
  const items = ref<any[]>([])

  const loadData = () => {
    const result = useLoadObjectSubTypeSelect()

    watchEffect(() => {
      if (result.data.value) {
        items.value = result.data.value.data || []
      }
    })

    return result
  }

  return {
    items,
    loadData,
  }
})
